module.exports = __webpack_public_path__ + "img/editIcon.c8420ad8.svg";